import axios from "axios";
import { getRolesByCountry } from "./GetRolesByCountryAction";
import {
  addRoleRequested,
  addRoleRequestSucceeded,
  addRoleRequestFailed,
} from "../slices/AddRoleSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Rol`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

export const AddRole = (role) => async (dispatch) => {
  try {
    dispatch(addRoleRequested());

    const postData = {
      roleName: role.roleName,
      isActive: role.isActive,
      addToAll: role.addToAll,
      countryId: Number(getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data === true) {
      dispatch(addRoleRequestSucceeded(response.data));
      await dispatch(getRolesByCountry());
      return { success: true, message: "Role created successfully" };
    }

    const errorMessage =
      "The role could not be created. A role with the same name may already exist.";
    dispatch(addRoleRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(addRoleRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
